import axios from '../Axios';
import { LOGOUT } from '../CONSTANTURL';

export const LOGOUTAPI = async () => {
  try {
    return await axios.delete(`${LOGOUT}`);
  } catch (err) {
    return {
      error: true,
      response: err.response
    };
  }
};

